import api from './api';

const DRAFT_ENDPOINT = '/accounting-export-drafts';

function buildScopeParams(type, year, month) {
    return { type, year: String(year), month: String(month) };
}

export function getAccountingExportDraft(type, year, month) {
    return api.get(DRAFT_ENDPOINT, buildScopeParams(type, year, month));
}

export function saveAccountingExportDraft(type, year, month, rows) {
    return api.put(DRAFT_ENDPOINT, { type, year, month, rows });
}

export function resetAccountingExportDraft(type, year, month) {
    const query = new URLSearchParams(buildScopeParams(type, year, month)).toString();
    return api.delete(`${DRAFT_ENDPOINT}?${query}`);
}
